import { render } from "./MyPromotion.vue?vue&type=template&id=c82a6a1a&scoped=true"
import script from "./MyPromotion.vue?vue&type=script&lang=js"
export * from "./MyPromotion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82a6a1a"]])

export default __exports__